import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useSpeciesServices = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allSpeciesService = useQuery({
    queryKey: [...CACHE_KEYS.SPECIES, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.SPECIES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allSpeciesService },
    states: { searchQuery, setSearchQuery },
  };
};
